module.exports = __webpack_public_path__ + "img/avatar_03.0a1fd48a.webp";